<template>
  <v-container class="cmp-catalog-tracks-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              selectedTrackDetails &&
              selectedTrackDetails.track &&
              selectedTrackDetails.track.title
            "
          >
            <span v-if="selectedTrackDetails && selectedTrackDetails.track"
              >{{ selectedTrackDetails.track.title || $t('track_name') }}
              <span v-if="selectedTrackDetails.track.version || ''">{{
                " (" + selectedTrackDetails.track.version + ")" ||
                $t('track_version')
              }}</span>
            </span>
          </div>
        </div>
        <div class="dt-details--body">
          <div class="dt-details--col">
            <div class="ut-flex">
              <div v-if="selectedTrackDetails && selectedTrackDetails.track">
                {{ selectedTrackDetails.track.artist || $t('artist_name') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <glayout
        :tabs="trackSidewindowTabs"
        :options="[
          {
            text: 'Labelcopy',
            value: 'labelcopy',
            popup: copyText,
          },
        ]"
        :loading="selectedTrackDetails && selectedTrackDetails.loading"
        @optionClicked="onLabelcopyClicked"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox :title="$t('track_setup')" h="451">
                <TrackSetup
                  :selectedTrackDetails="selectedTrackDetails"
                  @add_click="onSearchProductClick"
                  @changed="onTrackChanged"
                  @selected_product="onSelectedProduct"
                />
              </gbox>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedTrackDetails &&
                      selectedTrackDetails.track_genres &&
                      selectedTrackDetails.track_genres.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    max: 15,
                  })
                "
                :title="$t('genres')"
              >
                <TrackGenres
                  :selectedTrackDetails="selectedTrackDetails"
                  @add_click="onNewGenresClick"
                  @change="onGenreChange"
                  @deleted="onGenreDeleted"
                />
              </gbox>
              
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedTrackDetails &&
                      selectedTrackDetails.track_credits &&
                      selectedTrackDetails.track_credits.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('track_credits')"
              >
                <TrackCredits
                  :selectedTrackDetails="selectedTrackDetails"
                  @add_click="onTrackCreditAddClick"
                  @selected="onTrackCreditSelect"
                  @changed="onTrackChanged"
                  @deleted="onTrackDeleted"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedTrackDetails &&
                      selectedTrackDetails.track_additionals &&
                      selectedTrackDetails.track_additionals.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('additional_info')"
              >
                <TracksAdditionalInfo
                  :selectedTrackDetails="selectedTrackDetails"
                  @add_click="onTrackAdditionalAddClick"
                  @selected="onTrackAdditionalSelect"
                  @changed="onTrackChanged"
                  @deleted="onAdditionalInfoDeleted"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedTrackDetails &&
                      selectedTrackDetails.files &&
                      selectedTrackDetails.files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('related_documents')"
              >
                <DBoxFiles
                  :files="selectedTrackDetails.files"
                  :externalId="`${this.selectedTrackDetails.track.track_id}`"
                  :externalTable="'track'"
                />
              </gbox>

             
            </gcol>
          </grow>
        </gtab>
        <gtab
          id="relations"
          :title="$t('tab_tracks_relations')"
        >
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedTrackDetails &&
                      selectedTrackDetails.releases &&
                      selectedTrackDetails.releases.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :title="`${$t('tracks_related_releases')} (${releaseLength})`"
              >
                <DBoxRelatedReleases
                  :releases="selectedTrackDetails.releases"
                  @changed="onTrackChanged"
                  @selected="onSelectedRelease"
                />
              </gbox>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedTrackDetails &&
                      selectedTrackDetails.products &&
                      selectedTrackDetails.products.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :title="`${$t('tracks_related_products')} (${productLength})`"
              >
                <TrackRelatedProducts
                  :selectedTrackDetails="selectedTrackDetails"
                  @changed="onRelatedProductsChanged"
                  @selected="onSelectedProduct"
                />
              </gbox>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedTrackDetails &&
                      selectedTrackDetails.licensors &&
                      selectedTrackDetails.licensors.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :title="$t('tracks_licensors')"
              >
                <TrackLicensors :selectedTrackDetails="selectedTrackDetails" />
              </gbox>
            </gcol>
        
          </grow>
          <grow>
            <gcol>
              
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedTrackDetails &&
                      selectedTrackDetails.manual_matches &&
                      selectedTrackDetails.manual_matches.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :title="$t('tracks_manual_matches')"
              >
                <TrackManualMatches
                  :selectedTrackDetails="selectedTrackDetails"
                  @deleted="onManualMatchesDeleted"
                />
              </gbox>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedTrackDetails &&
                      selectedTrackDetails.licences &&
                      selectedTrackDetails.licences.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :title="$dft.capHead($t('tracks_licenses'))"
              >
                <TrackLicences :selectedTrackDetails="selectedTrackDetails" />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedTrackDetails &&
                      selectedTrackDetails.external_ids &&
                      selectedTrackDetails.external_ids.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('tracks_external_ids')"
              >
                <TrackExternalIds
                  :selectedTrackDetails="selectedTrackDetails"
                  @added="onAddedExternalIds"
                  @changed="onExternalIdsChanged"
                  @deleted="onExternalIdsDeleted"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="sales">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedTrackDetails &&
                      selectedTrackDetails.salesData &&
                      selectedTrackDetails.salesData.sales &&
                      selectedTrackDetails.salesData.sales.length,
                    rowHeight: 48,
                    min: 1,
                  })
                "
                :title="$t('ds_sales')"
              >
                <DBoxSales
                  :rightMenu="[]"
                  :hasTransaction="false"
                  :storeConfig="dboxSalesStoreConfig"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="metadata">
          <grow>
            <gcol>
              <gbox h="100%" :title="$t('metadata')">
                <MetaData
                  @changed="onMetaDataUpdate"
                  :detailsObject="selectedTrackDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        
      </glayout>
    </div>

    <ModalContainer :modalKey="'trackSearchProduct'" :width="'medium'">
      <TrackSearchProduct
        @cancelled="onDialogCancelled"
        @set_main_product="onSetMainProduct"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'trackCreditForm'" :width="'small'">
      <TrackCreditForm
        :selectedTrackDetails="selectedTrackDetails"
        @cancelled="onDialogCancelled"
        @added="onAdded"
        @edited="onEdited"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'trackAdditionalForm'" :width="'small'">
      <TrackAdditionalForm
        :selectedTrackDetails="selectedTrackDetails"
        @cancelled="onDialogCancelled"
        @added_additional_info="onAddedAdditionalInfo"
        @edited_additional_info="onEditedAdditionalInfo"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'trackGenresModal'" :width="'small'">
      <TrackGenresModal
        :selectedTrackDetails="selectedTrackDetails"
        @cancelled="onDialogCancelled"
        @added="onGenreAdded"
        @created="onCreatedGenre"
      />
    </ModalContainer>
  </v-container>
</template>

<script>
import { CatalogStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { checkTabListPermission } from "../../../../router/guard";
import {
  productsListLDTRoutes,
  releasesListLDTRoutes,
  tracksListLDTRoutes,
} from "../../router/routes";
import BoxWidget from "@plugins/box-widget/box-widget";
import TrackSetup from "./track-setup";
import TrackCredits from "./track_credits";
import { tracksCatalogGetters } from "../../store/tracks/getters";
import { tracksCatalogActions } from "../../store/tracks/actions";
import { createTV } from "../../../../models/text-value.model";
import DBoxFiles from "@/dt-plugins/dbox-files/dbox-files";
import DBoxRelatedReleases from "@/dt-plugins/dbox-related_releases/dbox-related_releases";
import MetaData from "@/dt-plugins/metadata/metadata";
import { createMailHref } from "../../../../utility";

import ModalContainer from "@dtplugins/modal/modal-container";
import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import { createDboxPluginStoreConfig } from "../../../../dt-plugins/dboxstore/dboxstore";
import DBoxSales from "@dtplugins/dbox-sales/dbox-sales";
import TrackSearchProduct from "./track-search-product";
import TrackCreditForm from "./track-credit-form";
import TracksAdditionalInfo from "./tracks-additional-info";
import TrackAdditionalForm from "./track-additional-form";
import TrackGenres from "./track-genres";
import TrackGenresModal from "./track-genres-modal";
import TrackLicensors from "./track-licensors";
import TrackRelatedProducts from "./track-related-products";
import TrackManualMatches from "./track-manual-matches";
import TrackExternalIds from "./track-external-ids";
import TrackLicences from "./track-licences";
import LabelCopy from "./labelcopy";
import { TracksService } from "../../services/tracks.service";

export const moduleRoute = "catalog";
export const submenuRoute = "tracks";

export default {
  components: {
    BoxWidget,
    ModalContainer,
    DBoxFiles,
    DBoxRelatedReleases,
    DBoxSales,
    MetaData,
    TrackSetup,
    TrackSearchProduct,
    TrackCredits,
    TrackCreditForm,
    TracksAdditionalInfo,
    TrackAdditionalForm,
    TrackGenres,
    TrackGenresModal,
    TrackLicensors,
    TrackRelatedProducts,
    TrackManualMatches,
    TrackExternalIds,
    TrackLicences,
    LabelCopy,
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("trackSearchProduct"),
    createModalMixin("trackCreditForm"),
    createModalMixin("trackAdditionalForm"),
    createModalMixin("trackGenresModal"),
  ],
  computed: {
    ...mapGetterObject(storeNS, tracksCatalogGetters),

    releaseLength:function(){
      
      return  this.selectedTrackDetails &&
                this.selectedTrackDetails.releases &&
                this.selectedTrackDetails.releases.length||0  
    },

    productLength:function(){
      
      return  this.selectedTrackDetails &&
                this.selectedTrackDetails.products &&
                this.selectedTrackDetails.products.length||0  
    },

    trackSidewindowTabs: function () {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        {
          route: "overview",
          value: this.$t("overview"),
        },
        {
          route: "relations",
          value: this.$t("tab_tracks_relations"),
        },
       
        {
          route: "sales",
          value: this.$t("tab_tracks_sales"),
        },
        {
          route: "metadata",
          value: this.$t("tab_tracks_metadata"),
        },
      ]);
    },

    // TABULATION REFACTORING

    track_id: function () {
      return this.$route.params.track_id;
    },

    selectedTrackDetails: function () {
      const selectedTrack = this.trackDetails?.[this.track_id] || {};

      const track = selectedTrack.track || {};

      const countries = selectedTrack?.countries || [];
      const countriesTV = createTV(countries);

      const digital_right_types = selectedTrack?.digital_right_types || [];
      const digitalRightTpyesTV = createTV(
        digital_right_types,
        "value",
        "index"
      );

      const track_product_languages =
        selectedTrack?.track_product_languages || [];
      const languagesTV = createTV(track_product_languages);

      const product = selectedTrack.product || {};
      let track_credits = selectedTrack?.track_credits || [];
      const trackFileTypes = selectedTrack.track_file_types || {};
      const track_additionals = selectedTrack.track_additionals || [];
      const track_genres = selectedTrack?.track_genres || [];
      const ranks = selectedTrack?.ranks || [];
      const files = selectedTrack?.files || [];
      const licensors = selectedTrack?.licensors || [];
      const licences = selectedTrack?.licences || [];
      const releases = selectedTrack?.releases || [];
      const products = selectedTrack?.products || [];
      const manual_matches = selectedTrack?.manual_matches || [];
      const external_ids = selectedTrack?.external_ids || [];
      const writers = selectedTrack?.writers || [];
      const publishers = selectedTrack?.publishers || [];
      const producers = selectedTrack?.producers || [];
      const composers = selectedTrack?.composers || [];
      const additionals = selectedTrack?.additionals || [];
      const arrangers = selectedTrack?.arrangers || [];
      const order = ['composer', 'writer', 'producer', 'arranger', 'publisher'];
      track_credits= track_credits.sort(function(a, b){
            return order.indexOf(a.type) - order.indexOf(b.type)
      });
      return {
        ...selectedTrack,
        track,
        countries,
        countriesTV,
        digital_right_types,
        digitalRightTpyesTV,
        track_product_languages,
        languagesTV,
        product,
        track_credits,
        trackFileTypes,
        track_additionals,
        track_genres,
        ranks,
        files,
        licensors,
        licences,
        releases,
        products,
        manual_matches,
        external_ids,
        writers,
        publishers,
        composers,
        additionals,
        producers,
        arrangers,
      };
    },

    copyText() {
      const body = `Artist: ${this.selectedTrackDetails.track.artist}<br/>Title: ${this.selectedTrackDetails.track.title}<br/>Version:${this.selectedTrackDetails.track.version}<br/>`;

      const body1 = `Playtime: ${this.selectedTrackDetails.track.playtime}<br/>Explicit Lyrics: ${this.selectedTrackDetails.track.explicit_flag}<br/>ISRC: ${this.selectedTrackDetails.track.isrc}<br/>(P):${this.selectedTrackDetails.track.p_year} ${this.selectedTrackDetails.track.p_line}<br/>`;

      const composer = this.selectedTrackDetails.composers.reduce(
        (accum, cur, index) => {
          const length = this.selectedTrackDetails.composers.length;

          if (length == index + 1) {
            accum += `${cur["name"]}`;
          } else {
            accum += `${cur["name"]} , `;
          }

          return accum;
        },
        "Composer: "
      );

      const writer = this.selectedTrackDetails.writers.reduce(
        (accum, cur, index) => {
          const length = this.selectedTrackDetails.writers.length;

          if (length == index + 1) {
            accum += `${cur["name"]}`;
          } else {
            accum += `${cur["name"]} , `;
          }

          return accum;
        },
        "Writer: "
      );

      const producers = this.selectedTrackDetails.producers.reduce(
        (accum, cur, index) => {
          const length = this.selectedTrackDetails.producers.length;

          if (length == index + 1) {
            accum += `${cur["name"]}`;
          } else {
            accum += `${cur["name"]} , `;
          }

          return accum;
        },
        "Producer: "
      );

      const publishers = this.selectedTrackDetails.publishers.reduce(
        (accum, cur, index) => {
          const length = this.selectedTrackDetails.publishers.length;

          if (length == index + 1) {
            accum += `${cur["name"]}`;
          } else {
            accum += `${cur["name"]} , `;
          }

          return accum;
        },
        "Publisher: "
      );

      const arrangers = this.selectedTrackDetails.arrangers.reduce(
        (accum, cur, index) => {
          const length = this.selectedTrackDetails.arrangers.length;

          if (length == index + 1) {
            accum += `${cur["name"]}`;
          } else {
            accum += `${cur["name"]} , `;
          }

          return accum;
        },
        "Arrangers: "
      );

      const additionals = this.selectedTrackDetails.additionals.reduce(
        (accum, cur) => {
          return (accum += `${cur["description"]}: ${cur["name"]}<br/>`);
        },
        ""
      );

      return `${body}${body1}Country: ${this.selectedTrackDetails.track.country}<br/><br/>${composer}<br/>${writer}<br/>${producers}<br/>${publishers}<br/>${arrangers}<br/>${additionals}`;
    },
    dboxSalesStoreConfig() {
      return createDboxPluginStoreConfig({
        storeNamesPace: storeNS,
        detailsAction: ActionTypes.TrackDetails,
        detailsGetterKey: "trackDetails",
        dataKey: "salesData",
        primaryKeyValue: this.track_id,
      });
    },
  },
  methods: {
    ...mapActionObject(storeNS, tracksCatalogActions),

    onLabelcopyClicked: function () {
      //const resData = await TracksService.getLabelCopy(this.track_id);

      //console.log(":::::::::::::::::",resData)

      //const txt = this.labelEmailBody(resData.data);

      location.href = createMailHref({
        subject:
          "Labelcopy: " +
          this.selectedTrackDetails.track.artist +
          " | " +
          this.selectedTrackDetails.track.title,
        body: this.copyText.replace(/(<([^>]+)>)/gi, `\n`),
        mails: [""],
      });
    },

    onFastHover: function (track_id) {
      // onFastHover: async function (track_id) {
      // const Payments = await InvoiceForwardService.getInvoiceTabForward(
      //   invoice_id
      // );
      // this.hoverPayments = Payments.data.artist_payments;
      // console.log("ID", this.hoverPayments);
    },
    onFastLeave: function (track_id) {
      console.log("ID Leave", track_id);
      // InvoiceForwardService.getInvoiceTabForward(invoice_id)
    },

    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onSearchProductClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "track_search_product",
        },
      });
    },
    // Start Track Credits
    onTrackCreditAddClick: function () {
      openModalRoute(this, "track_credit_form", {
        mode: "add",
      });
    },
    onTrackCreditSelect: function (selectedType) {
      openModalRoute(this, "track_credit_form", {
        mode: "edit",
        track_info_id: selectedType.track_info_id,
      });
    },
    onAdded: function (payload) {
      // How does getters.trackDetails contain track_id ? -- this.trackDetails[this.track_id] --- with Route
      // console.log('payload ', payload);
      this[ActionTypes.TrackCredits.SET.ALL]({
        ...payload,
        item: this.selectedTrackDetails,
      });
      this.onDialogCancelled();
    },
    onEdited: function (payload) {
      // console.log('Eidted payload ', payload);
      this[ActionTypes.TrackCredits.UPDATE.SINGLE](payload);
      this.onDialogCancelled();
    },
    onTrackDeleted: function (item) {
      // console.log('delete me tc ', item);
      this[ActionTypes.TrackCredits.DELETE.SINGLE]({
        // <-- Dispatch Method
        item,
        track_id: this.track_id,
      });
    },
    // End Track Credits

    // Start Track Additional
    onTrackAdditionalAddClick: function () {
      openModalRoute(this, "track_additional_form", {
        mode: "add",
      });
    },
    onTrackAdditionalSelect: function (selectedType) {
      openModalRoute(this, "track_additional_form", {
        mode: "edit",
        track_info_id: selectedType.track_info_id,
      });
    },
    onAddedAdditionalInfo: function (payload) {
      this[ActionTypes.TrackAdditionalInfo.SET.ALL]({
        ...payload,
        item: this.selectedTrackDetails,
      });
      this.onDialogCancelled();
    },
    onEditedAdditionalInfo: function (payload) {
      this[ActionTypes.TrackAdditionalInfo.UPDATE.SINGLE](payload);
      this.onDialogCancelled();
    },

    onAdditionalInfoDeleted: function (item) {
      this[ActionTypes.TrackAdditionalInfo.DELETE.SINGLE]({
        // <-- Dispatch Method
        item,
        track_id: this.track_id,
      });
    },
    // End Track Additional

    // Start Genres
    onNewGenresClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "track_genres_modal",
        },
      });
    },
    onGenreAdded: function (selectedGenre) {
      this[ActionTypes.TrackGenre.SET.ALL]({
        ...selectedGenre,
        track_id: this.track_id,
      });
      this.onDialogCancelled();
    },
    onGenreChange: function (payload) {
      this[ActionTypes.TrackGenre.UPDATE.SINGLE]({
        ...payload,
        selectedTrackDetails: this.selectedTrackDetails,
      });
    },
    onCreatedGenre: function (payload) {
      this[ActionTypes.TrackGenre.SET.ALL]({
        ...payload,
        track_id: this.track_id,
      });
      this.onDialogCancelled();
    },
    onGenreDeleted: function (item) {
      this[ActionTypes.TrackGenre.DELETE.SINGLE]({
        // <-- Dispatch Method
        item,
        track_id: this.track_id,
      });
    },
    // End Genres

    onTrackChanged: function (payload) {
      this[ActionTypes.TrackDetails.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedTrackDetails,
      });
    },

    onSetMainProduct: function (payload) {
      this[ActionTypes.SET_MAIN_PRODUCT](payload);
      this.onDialogCancelled();
    },

    onSelectedProduct: function (selectedProductId) {
      this.$router.push({
        name: productsListLDTRoutes.names.tab,
        params: {
          product_id: selectedProductId,
          tab: "overview",
        },
      });
    },

    onSelectedRelease: function (selectedReleaseId) {
      this.$router.push({
        name: releasesListLDTRoutes.names.tab,
        params: {
          release_id: selectedReleaseId,
          tab: "overview",
        },
      });
    },

    // Start External Ids
    onAddedExternalIds: function (payload) {
      this[ActionTypes.TrackExternalIds.SET.ALL]({
        ...payload,
        item: this.selectedTrackDetails,
      });
      this.onDialogCancelled();
    },

    onExternalIdsChanged: function (payload) {
      this[ActionTypes.TrackExternalIds.UPDATE.SINGLE]({
        ...payload,
        selectedTrackDetails: this.selectedTrackDetails,
      });
    },

    onExternalIdsDeleted: function (item) {
      this[ActionTypes.TrackExternalIds.DELETE.SINGLE]({
        // <-- Dispatch Method
        item,
        track_id: this.track_id,
      });
    },
    // End External Ids

    // Start Manual Matches
    onManualMatchesDeleted: function (item) {
      this[ActionTypes.TrackManualMatches.DELETE.SINGLE]({
        // <-- Dispatch Method
        item,
        track_id: this.track_id,
      });
    },
    // End Manual Matches

    // Start Related Products
    onRelatedProductsChanged: function (payload) {
      this[ActionTypes.TrackRelatedProducts.UPDATE.SINGLE]({
        ...payload,
        selectedTrackDetails: this.selectedTrackDetails,
      });
    },
    // End Related Products

    // Start Meta Data
    onMetaDataUpdate: function (payload) {
      this[ActionTypes.MetaData.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedTrackDetails.track,
      });
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-catalog-tracks-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 150px);
  }
}
</style>
